import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import EmptyRouterView from '@/components/EmptyRouterView';

// Lazy laoding route components
const Homepage = () =>
  import(
    /* webpackChunkName: "home" */
    /* webpackPrefetch: true */
    '@/components/homepage/Homepage'
  );
const DirectDebitPayment = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/userSettings/DirectDebitPayment'
  );

const EventDetails = () =>
  import(
    /* webpackChunkName: "event-details" */
    /* webpackPrefetch: true */
    '@/components/event/eventDetails/EventDetails'
  );
const Reviews = () =>
  import(
    /* webpackChunkName: "event-details" */
    /* webpackPrefetch: true */
    '@/components/homepage/Reviews'
  );

const Booking = () =>
  import(
    /* webpackChunkName: "booking" */
    /* webpackPrefetch: true */
    '@/components/booking/Booking'
  );
const Payment = () =>
  import(
    /* webpackChunkName: "booking" */
    /* webpackPrefetch: true */
    '@/components/booking/Payment'
  );

const PartnerGroupSubscription = () =>
  import(
    /* webpackChunkName: "subscription" */
    /* webpackPrefetch: true */
    '@/components/subscription/PartnerGroupSubscription'
  );
const EventSubscription = () =>
  import(
    /* webpackChunkName: "subscription" */
    /* webpackPrefetch: true */
    '@/components/subscription/EventSubscription'
  );
const SubscriptionPayment = () =>
  import(
    /* webpackChunkName: "subscription" */
    /* webpackPrefetch: true */
    '@/components/subscription/SubscriptionPayment'
  );

const UserSettings = () =>
  import(
    /* webpackChunkName: "user-settings" */
    /* webpackPrefetch: true */
    '@/components/userSettings/UserSettings'
  );
const Activities = () =>
  import(
    /* webpackChunkName: "user-settings" */
    /* webpackPrefetch: true */
    '@/components/activities/Activities'
  );
const QuizQuestions = () =>
  import(
    /* webpackChunkName: "event" */
    /* webpackPrefetch: true */
    '@/components/event/eventDetails/QuizQuestions'
  );

const PrivacyStatement = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/other/PrivacyStatement'
  );

const TermsAndConditions = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/other/TermsAndConditions'
  );

const AboutUs = () =>
  import(
    /* webpackPrefetch: true */
    '@/components/homepage/AboutUs'
  );

const Test = () =>
  import(
    /* webpackChunkName: "develop" */
    /* webpackPrefetch: true */
    '@/components/Test'
  );

Vue.use(Router);

const router = new Router({
  trailingSlashes: 'true',
  mode: 'history',
  routes: [
    {
      path: '/',
      component: EmptyRouterView,
      children: [
        {
          // Redirecting to Homepage
          path: '',
          name: 'Homepage',
          component: Homepage,
          beforeEnter: (to, from, next) => {
            if (store.getters.getRegion !== '' && to.params.account_id === '') {
              to.params.account_id = store.getters.getRegion;
            }

            if (!store.getters.getRegion) {
              store.commit('setRegion', to.params.account_id);
            }

            next({});
          },
        },
        {
          // redirecting to test scanner account page
          path: 'login',
          name: 'Login',
          component: Homepage,
          beforeEnter: (to, from, next) => {
            if (store.getters['auth/userName'] === '') {
              // User is not logged in
              setTimeout(() => {
                window.EventBus.fire('triggerOpenAccountFromMenu', {
                  toggle: true,
                  component: 'Login',
                });
              }, 1000);
            }
            next({});
          },
        },
        {
          // redirecting to test scanner account page
          path: 'register',
          name: 'Register',
          component: Homepage,
          beforeEnter: (to, from, next) => {
            if (store.getters['auth/userName'] === '') {
              // User is not logged in
              setTimeout(() => {
                window.EventBus.fire('triggerOpenAccountFromMenu', {
                  toggle: true,
                  component: 'Register',
                });
              }, 1000);
            }
            next({});
          },
        },
        {
          // redirecting to test scanner account page
          path: 'test',
          name: 'Test',
          component: Test,
        },
        {
          path: 'activities',
          name: 'Activities',
          component: Activities,
        },
        {
          path: 'event=:event_id/questions',
          name: 'QuizQuestions',
          component: QuizQuestions,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            next({});
          },
        },
        {
          path: 'privacyStatement',
          name: 'PrivacyStatement',
          component: PrivacyStatement,
          props: true,
        },
        {
          path: 'termsAndConditions',
          name: 'TermsAndConditions',
          component: TermsAndConditions,
          props: true,
        },
        {
          path: 'booking',
          name: 'Booking',
          component: Booking,
        },
        {
          path: 'userSettings',
          name: 'UserSettings',
          component: UserSettings,
        },
        // review page with more than four reviews
        {
          path: 'reviews',
          name: 'Reviews',
          component: Reviews,
          props: true,
        },
        {
          path: 'unsubscribe/details',
          name: 'Unsubscribe',
          component: Homepage,
          beforeEnter: (to, from, next) => {
            if (!store.getters.getRegion) {
              store.commit('setRegion', to.params.account_id);
            }
            store.commit('setUserToUnsubscribe', {
              User: to.query.User,
              Partner: to.query.Partner,
              Account: to.query.Account,
            });
            setTimeout(() => {
              window.EventBus.fire('triggerOpenAccountFromMenu', {
                toggle: true,
                component: 'Unsubscribe',
              });
            }, 1000);
            next({});
          },
        },
        {
          path: 'unsubscribe/PartnerGroup=:partnerGroup/details',
          name: 'UnsubscribeWithPartnerGroup',
          component: Homepage,
          beforeEnter: (to, from, next) => {
            if (!store.getters.getRegion) {
              store.commit('setRegion', to.params.account_id);
            }
            store.commit('setUserToUnsubscribe', {
              User: to.query.User,
              Partner: to.query.Partner,
              Account: to.query.Account,
            });
            setTimeout(() => {
              window.EventBus.fire('triggerOpenAccountFromMenu', {
                toggle: true,
                component: 'Unsubscribe',
              });
            }, 1000);
            next({});
          },
        },

        {
          // Products subscription creation from partner group
          path: 'subscription',
          name: 'PartnerGroupSubscription',
          component: PartnerGroupSubscription,
        },
        {
          // Products subscription creation from event
          path: 'subscription/event/:event_id',
          name: 'EventSubscription',
          component: EventSubscription,
        },

        /**
         * The section below is for all the email redirects
         */
        {
          path: 'activateUser/PartnerGroup=:partnerGroup/activateUser',
          name: 'ActivateUser',
          component: Homepage,
          beforeEnter: (to, from, next) => {
            if (!store.getters.getRegion) {
              store.commit('setRegion', to.params.account_id);
            }

            // Clear the token. This link is for nologin users
            store.commit('auth/setToken', '');
            store.commit('auth/setUserName', '');

            setTimeout(() => {
              window.EventBus.fire('triggerOpenAccountFromMenu', {
                toggle: true,
                component: 'Activate',
              });
            }, 1000);
            next({});
          },
        },
        {
          path: 'userConfirmation',
          name: 'userConfirmation',
          component: Homepage,
          beforeEnter: (to, from, next) => {
            if (!store.getters.getRegion) {
              store.commit('setRegion', to.params.account_id);
            }
            setTimeout(() => {
              window.EventBus.fire('triggerOpenUserConfirmation', {
                toggle: true,
                email: to.query.Email,
                orderId: to.query.OrderID,
                action: to.query.action,
              });
            }, 1000);
            next({});
          },
        },
        {
          path: 'resetPassword/PartnerGroup=:partnerGroup/resetPassword',
          name: 'ChangePassword',
          component: Homepage,
          beforeEnter: (to, from, next) => {
            if (!store.getters.getRegion) {
              store.commit('setRegion', to.params.account_id);
            }

            // Clear the token. This link is for nologin users
            store.commit('auth/setToken', '');
            store.commit('auth/setUserName', '');

            setTimeout(() => {
              window.EventBus.fire('triggerOpenAccountFromMenu', {
                toggle: true,
                component: 'ChangePassword',
              });
            }, 1000);
            next({});
          },
        },

        // Routes related to payment
        {
          // Redirection url for mollie payment to complete the order
          path: 'payments/PartnerGroup=:partnerGroup/redirect/:paymentId',
          name: 'Payment',
          component: Payment,
          beforeEnter: (to, from, next) => {
            if (!store.getters.getRegion) {
              store.commit('setRegion', to.params.account_id);
            }
            next({});
          },
        },
        {
          // Redirection url for mollie payment to activate direct debit in user settings screen
          path: 'directdebit/PartnerGroup=:partnerGroup/order/:orderId/user/:userId',
          name: 'DirectDebitPayment',
          component: DirectDebitPayment,
          beforeEnter: (to, from, next) => {
            if (!store.getters.getRegion) {
              store.commit('setRegion', to.params.account_id);
            }
            next({});
          },
        },
        {
          // Redirection url for mollie payment to activate direct debit for subscription creation
          path: 'subscriptionpayment/PartnerGroup=:partnerGroup/order/:orderId/user/:userId',
          name: 'SubscriptionPayment',
          component: SubscriptionPayment,
          beforeEnter: (to, from, next) => {
            if (!store.getters.getRegion) {
              store.commit('setRegion', to.params.account_id);
            }
            next({});
          },
        },

        /**
         * Routes related to event
         */
        {
          // Event details page
          path: 'event=:event_id',
          name: 'EventDetails',
          component: EventDetails,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            next({});
          },
        },
        {
          // Event details page from an URL without SourceKey
          path: 'showEvent/PartnerGroup=:partnerGroup/event=:event_id',
          name: 'ShowEventDetails',
          component: EventDetails,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            next({});
          },
        },
        {
          // Event details page from an URL with SourceKey
          path: 'showEvent/PartnerGroup=:partnerGroup/event=:event_id/details',
          name: 'ShowEventDetailsWithSourceKey',
          component: EventDetails,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            next({});
          },
        },

        /**
         * Routes related to product category
         */
        {
          // Product category page
          path: 'event=:event_id/productCategory=:category_id',
          name: 'ProductCategory',
          component: EventDetails,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            store.commit('event/setCurrentCategoryId', to.params.category_id);
            next({});
          },
        },
        {
          // Product category page from an URL without SourceKey
          path: 'showEvent/PartnerGroup=:partnerGroup/event=:event_id/productCategory=:category_id',
          name: 'ShowProductCategory',
          component: EventDetails,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            store.commit('event/setCurrentCategoryId', to.params.category_id);
            next({});
          },
        },
        {
          // Product category page from an URL with SourceKey
          path: 'showEvent/PartnerGroup=:partnerGroup/event=:event_id/productCategory=:category_id/details',
          name: 'ShowProductCategoryWithSourceKey',
          component: EventDetails,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            store.commit('event/setCurrentCategoryId', to.params.category_id);

            next({});
          },
        },

        /**
         * Routes related to product
         */
        {
          // Product details page with category id
          path: 'event=:event_id/category=:category_id/product=:product_id',
          name: 'ProductWithCategory',
          component: EventDetails,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            store.commit('event/setCurrentProductId', to.params.product_id);
            next({});
          },
        },
        {
          // Product details page without category id
          path: 'event=:event_id/product=:product_id',
          name: 'ProductWithoutCategory',
          component: EventDetails,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            store.commit('event/setCurrentProductId', to.params.product_id);
            next({});
          },
        },
        {
          // Product page from an URL without SourceKey
          path: 'showEvent/PartnerGroup=:partnerGroup/event=:event_id/product=:product_id',
          name: 'ShowProduct',
          component: EventDetails,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            store.commit('event/setCurrentProductId', to.params.product_id);
            next({});
          },
        },
        {
          // Product page from an URL with SourceKey
          path: 'showEvent/PartnerGroup=:partnerGroup/event=:event_id/product=:product_id/details',
          name: 'ShowProductWithSourceKey',
          component: EventDetails,
          beforeEnter: (to, from, next) => {
            store.commit('event/setCurrentEventId', to.params.event_id);
            store.commit('event/setCurrentProductId', to.params.product_id);
            next({});
          },
        },

        {
          path: 'aboutUs',
          name: 'AboutUs',
          component: AboutUs,
        },
      ],
      beforeEnter: (to, from, next) => {
        /* Check token in the url. If token exists, use this to log user in
        Use case: administrator log in as a customer from the partner web */
        const accessToken = to.query.access_token;
        const userId = to.query.id;
        if (accessToken && userId) {
          store.commit('auth/setToken', accessToken);
          store.commit('auth/setUserName', userId);
          next({ path: '' });
        } else {
          next({});
        }
      },
    },
    {
      path: '*',
      redirect: {
        name: 'Homepage',
      },
    },
  ],
});

export default router;
